module.exports = __webpack_public_path__ + "static/media/bg2.f2e51312.jpg";